import { render, staticRenderFns } from "./recap.vue?vue&type=template&id=613bca26&scoped=true&"
import script from "./recap.vue?vue&type=script&lang=js&"
export * from "./recap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bca26",
  null
  
)

export default component.exports